/* Copyright (c) Trimble Inc. All rights reserved. */
import { WelcomeBanner } from "pages/home/Starter";
import React, { useEffect } from "react";
import { ConsoleFeatures } from "./GuestHome";
import { useSelector } from "react-redux";
import GuestClient from "pages/home/consumer/service/GuestClient";

export const GuestHomePage:React.FC = () => {
    let accessToken = useSelector((state: any) => state.auth?.user?.access_token);

    useEffect(()=>{
      GuestClient.useToken?.(accessToken);
    },[accessToken]);
    
    return (
        <>
        <WelcomeBanner/>
        <ConsoleFeatures/>
        </>
    )
};

export default GuestHomePage;
